import { makeStyles } from "@fluentui/react-components";

const useModifyCoverageStyles = makeStyles({
    errorCard: {
        marginBottom: "4px",
        paddingLeft: "8px",
        paddingRight: "8px",
    }
});
export default useModifyCoverageStyles;